<template>
    <div class="">
        <div style="text-align: center;font-size: 16px;margin-top: 40%">账号存在异常</div>
    </div>
</template>
<script>
    export default {
        name: 'black',
        data() {
            return {
            }
        },
        created: function () {

        },
        methods: {

        }
    }
</script>

<style>
</style>
